<div class="collapse">
  <p class="collapse-trigger text-04-m-demibold" (click)="toggleActive()">
    3. Email<span class="icon icon-arrow-right visible-xs"></span><span class="icon icon-chevron-down hidden-xs" [class.active]="isActive"></span>
  </p>
  <div class="collapsed" [class.active]="isActive">
    <div class="modify-title step">
      <span class="collapse-horizontal-trigger icon icon-arrow-left"></span>
      <p class="text-10-m-demibold">3. EMAIL</p>
      <span class="icon icon-cancel"></span>
    </div>
    <ul class="submenu">
      <li singleColumnSw class="question-item"></li>
    </ul>
  </div>
</div>
